<template>
  <div class="tab-bar">
    <div>{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'Top',
  props: ['text'],
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab-bar {
  width: 100%;
  height: 3rem;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.tab-bar div {
  font-size: 18px;
  line-height: 3rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue